const CookIslandsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111209)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.95242 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3106 20H19.9466C19.9644 19.9822 19.9822 19.9644 20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38949 6.99004 2.6084 10.1181V19.9997H7.82582V7.82598V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M19.9993 17.5403L12.8935 10.4346H10.4341V10.4347L19.9992 19.9997H19.9993C19.9993 19.9997 19.9993 18.3039 19.9993 17.5403Z"
        fill="#D80027"
      />
      <path
        d="M26.9559 20L27.3261 21.1387H28.5234L27.5548 21.8425L27.9248 22.9813L26.9559 22.2775L25.9873 22.9813L26.3573 21.8425L25.3887 21.1387H26.5859L26.9559 20Z"
        fill="#F0F0F0"
      />
      <path
        d="M22.038 22.0375L23.1048 22.581L23.9515 21.7344L23.7642 22.917L24.831 23.4606L23.6484 23.6478L23.4611 24.8306L22.9174 23.7637L21.7349 23.951L22.5817 23.1044L22.038 22.0375Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 26.9559L21.1387 26.5859L21.1389 25.3887L21.8425 26.3572L22.9813 25.9871L22.2775 26.9559L22.9813 27.9247L21.8425 27.5547L21.1389 28.5233V27.326L20 26.9559Z"
        fill="#F0F0F0"
      />
      <path
        d="M22.038 31.8751L22.5815 30.8082L21.7349 29.9616L22.9175 30.1489L23.4611 29.082L23.6484 30.2647L24.831 30.4519L23.7642 30.9955L23.9515 32.1783L23.1048 31.3314L22.038 31.8751Z"
        fill="#F0F0F0"
      />
      <path
        d="M26.956 33.9139L26.586 32.7751H25.3887L26.3573 32.0714L25.9873 30.9326L26.956 31.6364L27.9248 30.9326L27.5548 32.0714L28.5234 32.7751H27.3262L26.956 33.9139Z"
        fill="#F0F0F0"
      />
      <path
        d="M31.8751 31.8751L30.8082 31.3316L29.9616 32.1783L30.1489 30.9955L29.082 30.452L30.2647 30.2647L30.452 29.082L30.9955 30.1489L32.1782 29.9616L31.3314 30.8083L31.8751 31.8751Z"
        fill="#F0F0F0"
      />
      <path
        d="M33.9125 26.9559L32.7737 27.326V28.5233L32.0699 27.5546L30.9312 27.9247L31.635 26.9559L30.9312 25.9871L32.0699 26.3572L32.7737 25.3887V26.5859L33.9125 26.9559Z"
        fill="#F0F0F0"
      />
      <path
        d="M31.8751 22.0375L31.3316 23.1043L32.1782 23.9509L30.9955 23.7636L30.452 24.8305L30.2647 23.6477L29.082 23.4605L30.1489 22.917L29.9616 21.7344L30.8083 22.5809L31.8751 22.0375Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111209">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CookIslandsSvg;
